export function CommercialShowcase() {
  return (
    <section id="commercial" className="relative overflow-hidden">
      <div className="grid lg:grid-cols-12">
        <div className="lg:col-span-7 relative h-[600px] lg:h-auto order-2 lg:order-1">
          <img 
            src="https://public.readdy.ai/ai/img_res/349dbd665ec6a9dbbea8c45467adde68.jpg"
            alt="Commercial remodeling Las Vegas - business property renovation"
            className="w-full h-full object-cover"
            title="RW Construction Commercial Projects"
          />
          <div className="absolute bottom-8 right-8 bg-white rounded-2xl shadow-2xl p-6 max-w-xs">
            <div className="text-3xl font-bold text-[#2C2C2C] mb-1">400+</div>
            <div className="text-gray-600 text-sm mb-3">Commercial Projects Completed</div>
            <div className="flex gap-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <i key={star} className="ri-star-fill text-[#FF6B35] text-lg"></i>
              ))}
            </div>
          </div>
        </div>

        <div className="lg:col-span-5 bg-[#2C2C2C] py-24 px-12 flex items-center order-1 lg:order-2">
          <div>
            <div className="mb-4">
              <span className="text-white/90 text-sm font-semibold tracking-wider uppercase">Commercial</span>
            </div>
            <h2 className="text-5xl font-bold text-white mb-6 leading-tight">Elevate Your Business</h2>
            <p className="text-white/95 text-base leading-relaxed mb-8">
              Professional commercial remodeling services that minimize downtime and maximize impact. We understand the unique needs of businesses and deliver quality results on time and within budget.
            </p>
            <button className="border-2 border-[#FF6B35] bg-[#FF6B35] text-white px-8 py-3 rounded-full text-sm font-semibold hover:bg-transparent hover:border-white transition-all whitespace-nowrap cursor-pointer">
              View Commercial Projects
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}